import { IFilters } from "../interfaces/IOrderFilters";

export type orderStatus = "ACCEPTED" | "PLACED" | "FUNDS_RECEIVED";


/**
 * Returns a filtered string for API
 * @param filters filtersObject
 * @param orderStatus Order status
 */
export function orderStatusFilter(filters: IFilters, orderStatus: orderStatus) {
    const queryFields: string[] = [`order_status=${orderStatus}`];
    orderFilter(filters, queryFields);
    return `?${queryFields.join("&")}`;
}

export function orderFilter(filters: IFilters, queryFields: string[]) {
    for (const area of Object.keys(filters?.tableAreas)) {
        if (filters.tableAreas[area]) { queryFields.push(`table_area=${area}`); }
    }
    if (filters?.COLLECTION) {
        queryFields.push(`order_type=COLLECTION`);
        queryFields.push(`order_type=COLLECTION_POINT_PICKUP`);
    }
    if (filters?.HOME_DELIVERY) {
        queryFields.push(`order_type=HOME_DELIVERY`);
    }
    if (filters?.TABLE_DELIVERY) {
        queryFields.push(`order_type=TABLE_DELIVERY`);
    }
}

/**recursive function for retrieving the filter count */
export function orderFilterCount(filters: IFilters | Record<string, boolean>) {
    let count = 0;
    for (const filterKey in filters) {
        const obj = filters[filterKey];
        if (typeof obj === "boolean" && obj === true) {
            count++;
        } else if (typeof obj === "object") {
            /**If the child is an object then re-call self */
            const childCount = orderFilterCount(obj);
            count += childCount;
        }
    }
    return count;
}